import { Inject, Injectable } from "@angular/core";
import { RaygunClientSettings } from "../models/raygunclientsettings";
import { HttpClient } from "@angular/common/http";
import { RaygunStateService } from "./raygun-state.service";
import { isNullOrUndefined } from '../../helpers/tools';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { catchError } from "rxjs/internal/operators/catchError";
import { NavigationEnd, NavigationError } from "@angular/router";
import { throwError } from "rxjs/internal/observable/throwError";
import rg4js, { RaygunPayload } from 'raygun4js';

@Injectable({
    providedIn: 'root'
})
export class RaygunService {

    public raygunClientSettings: RaygunClientSettings;

    constructor(private _http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private _raygunStateService: RaygunStateService) {

    }

    public get versionDetail(): string {
        if (!isNullOrUndefined(this.raygunClientSettings)) {

            let versionSuffix = '';

            if (!isNullOrUndefined(this.raygunClientSettings.environment)) {
                if (this.raygunClientSettings.environment !== '' && this.raygunClientSettings.environment.toLowerCase() !== 'beta') {
                    versionSuffix = " - " + this.raygunClientSettings.environment;
                }
            }

            return " v" + this.raygunClientSettings.version + versionSuffix;
        } else {
            return null;
        }
    }

    public async loadRaygunSettings() {
        this.raygunClientSettings = await firstValueFrom(this._http.get<RaygunClientSettings>(this.baseUrl + "api/raygun/settings").pipe(catchError(this.handleHttpError)));
        console.log(`Raygun enabled: ${!!this.raygunClientSettings?.apiKey}`);
        if (!isNullOrUndefined(this.raygunClientSettings) && this.raygunClientSettings.apiKey) {
            this._raygunStateService.useRaygun = true;
            rg4js('apiKey', this.raygunClientSettings.apiKey);
            rg4js('setVersion', this.raygunClientSettings.version);

            rg4js('enableCrashReporting', true);
            rg4js('enablePulse', true);
            rg4js("onBeforeSend", (p) => this.redirectBeforeSendBaseUrl(p)); // standardise js.map stacktrace URLs
        } else {
            this._raygunStateService.useRaygun = false;
        }
    }

    /**
     * Change all the stacktrace URLs to the standard base URL
     * @param payload Raygun payload
     * @returns
     */
    private redirectBeforeSendBaseUrl(payload: RaygunPayload) {
        var stacktrace = payload.Details.Error.StackTrace;

        for (var i = 0; i < stacktrace.length; i++) {
            var stackline = stacktrace[i];
            stackline.FileName = this.normalizeJsFilename(stackline.FileName);
        }
        return payload;
    }

    /**
     * Changes the filename to a standard base path
     * @param filename the path to the js file
     * @returns
     */
    private normalizeJsFilename(filename: string) {
        return filename.replace(this.baseUrl, `https://ratasourcemaps.blob.core.windows.net/rata/${this.raygunClientSettings.version}/cloud/`);
    }

    private handleHttpError(error: Response) {
        return throwError(error.statusText);
    }

    public trackEvent(event: NavigationEnd) {
        if (this.raygunClientSettings.apiKey) {
            // Track navigation end
            rg4js('trackEvent', {
                type: 'pageView',
                path: event.url
            });
        }
    }

    public sendEvent(event: NavigationError) {
        if (this.raygunClientSettings.apiKey) {
            // Track navigation error
            rg4js('send', {
                error: event.error
            });
        }
    }

}
